export const getAllAttackCategories = (entry) => {
	let categories = [];
	let mainCount = 0;

if (!!entry.attackTypes && entry.attackTypes.length) {
	categories = [...categories, ...entry.attackTypes];
	mainCount++
}
if (!!entry.attackVectors && entry.attackVectors.length) {
	categories = [...categories, ...entry.attackVectors];
	mainCount++
}
if (!!entry.attackGoals && entry.attackGoals.length) {
	categories = [...categories, ...entry.attackGoals];
	mainCount++
}
  
	if (!!entry.attackTactics?.length) categories = [...categories, ...entry.attackTactics];
	if (!!entry.attackThemes?.length) categories = [...categories, ...entry.attackThemes ];
	if (!!entry.attackImpersonatedParties?.length) categories = [...categories, ...entry.attackImpersonatedParties];
	if (!!entry.attackImpersonatedBrands?.length) categories = [...categories, ...entry.attackImpersonatedBrands];
	if (!!entry.attackLanguage?.length) categories = [...categories, ...entry.attackLanguage];
	if (!!entry.attackAttachmentType?.length) categories = [ ...categories, ...entry.attackAttachmentType];
	
  return [categories, mainCount];
};
